import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(({ palette,variables }) => ({
  orderDetailTabsWrapper: {
   padding: `0 ${variables?.spacingD}`
  },

  orderDetailIndicator: {
    '& .MuiTabs-indicator': {
      backgroundColor: palette.jet?.contentBrand
    },
    '& .MuiTab-wrapper': {
      color: palette.jet?.contentDefault,
      textTransform: 'capitalize'
    }
  }
}));

export default styles;
